import { render, staticRenderFns } from "./report-provider.vue?vue&type=template&id=3b8d662f&"
import script from "./report-provider.vue?vue&type=script&lang=js&"
export * from "./report-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports